import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BibliographicResourceTypeComponent } from './bibliographic-resource-type.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BibliographicResourceTypeComponent],
  exports: [BibliographicResourceTypeComponent],
})
export class BibliographicResourceTypeModule {}
